import dayjs from 'dayjs'
import React, { useEffect } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { DateInput } from 'semantic-ui-calendar-react'
import { Form } from 'semantic-ui-react'
import { getDateWithoutTime, parseDate } from '~/utils/helpers'
import { StyledErrorLabel } from '../../MilkMoney/MilkDelivery/ShowTours/style'
import { getError } from '~/components/FormFields/util'
import { LanguageType } from '~/api/services/auth'

interface Props {
  languageLocal: LanguageType
}

const Periods:React.FC<Props> = ({ languageLocal }) => {
  const { t } = useTranslation()
  const { control, setValue, formState: { isSubmitted } } = useFormContext()

  const todaysData = dayjs(new Date()).format('DD.MM.YYYY')
  const watchPeriodFrom = useWatch({ control, name: 'periodFrom' })
  const watchPeriodTo = useWatch({ control, name: 'periodTo' })

  useEffect(() => {
    if (watchPeriodFrom && watchPeriodTo) {
      const periodFrom = getDateWithoutTime(watchPeriodFrom)
      const periodTo = getDateWithoutTime(watchPeriodTo)
      if (dayjs(periodTo).diff(dayjs(periodFrom)) <= 0) {
        setValue('periodTo', getDayAhead(watchPeriodTo))
      }
    }
  }, [watchPeriodFrom])

  function getDayAhead(date) {
    const inputDate = parseDate(date)
    const parsedDate = dayjs(inputDate, { format: 'DD.MM.YYYY' });
    if (parsedDate.isValid()) {
      const previousDay = parsedDate.add(1, 'day');
      return previousDay.format('DD.MM.YYYY');
    }
    return parsedDate.format('DD.MM.YYYY')
  }

  function getDayBehind(date, numberBehind = 1) {
    const inputDate = parseDate(date)
    const parsedDate = dayjs(inputDate, { format: 'DD.MM.YYYY' });
    if (parsedDate.isValid()) {
      const previousDay = parsedDate.subtract(numberBehind, 'day');
      return previousDay.format('DD.MM.YYYY');
    }
    return parsedDate.format('DD.MM.YYYY')
  }

  const handleKeyPress = (event) => {
    event.preventDefault();
  }
 
  return <Form.Group widths={'equal'}>
    <Controller
      control={control}
      name={'periodFrom'}
      rules={{
        required: {
          value: true,
          message: t('Please enter period from')
        }
      }}
      render={({ field, fieldState }) => {
        return <Form.Field
          required
          error={!watchPeriodFrom && isSubmitted ? getError(fieldState) : false}
        >
          <label>{t('Period from')}</label>
          <DateInput
            name='date'
            placeholder={t('Period from')}
            maxDate={getDayBehind(todaysData, 2)}
            initialDate={getDayBehind(todaysData, 2)}
            closable
            onKeyDown={handleKeyPress}
            markColor={'blue'}
            localization={languageLocal.code}
            closeOnMouseLeave={false}
            dateFormat={'DD.MM.YYYY'}
            className={'datePicker'}
            value={watchPeriodFrom}
            iconPosition='left'
            onChange={(event, { name, value }) => setValue('periodFrom', value)}
          />
        </Form.Field>

      }}
    />
    <Controller
      control={control}
      name={'periodTo'}
      rules={{
        required: {
          value: true,
          message: t('Please enter period to')
        }
      }}
      render={({ field, fieldState }) => {
        const dateFrom = getDateWithoutTime(watchPeriodFrom || '')
        const dateTo = getDateWithoutTime(watchPeriodTo || '')
        const todaysDate = dayjs(new Date()).format('DD.MM.YYYY')
        return <Form.Field
          required
          error={!watchPeriodTo && isSubmitted ? getError(fieldState) : false}
        >
          <label>{t('Period to')}</label>
          <DateInput
            name='date'
            className={'datePicker'}
            placeholder={t('Period to')}
            closable
            markColor={'blue'}
            onKeyDown={handleKeyPress}
            onKeyPress={handleKeyPress}
            initialDate={getDayAhead(watchPeriodFrom || todaysDate)}
            minDate={getDayAhead(watchPeriodFrom || todaysDate)}
            maxDate={getDayBehind(todaysData, 1)}
            localization={languageLocal.code}
            closeOnMouseLeave={false}
            dateFormat={'DD.MM.YYYY'}
            disabled={!watchPeriodFrom}
            value={watchPeriodTo}
            iconPosition='left'
            onChange={(event, { name, value }) => setValue('periodTo', value)}
          />
          {!watchPeriodTo && isSubmitted && <StyledErrorLabel className='ui pointing basic label'>{t('Please enter period to')}</StyledErrorLabel>}
          {dateFrom && dateTo && dayjs(dateTo).diff(dayjs(dateFrom)) < 0 &&
                <StyledErrorLabel className='ui pointing basic label'>{t('Please select a date ahead of the period from.')}</StyledErrorLabel>}
        </Form.Field>

      }}
    />
  </Form.Group>
}
export default Periods